import styled from 'styled-components';

const StepsMLStyled = styled.div`
  .step-wrap {
    padding: 0;
    .step-icon-style {
      width: 42px;
      height: 42px;
    }
    .MuiStepLabel-alternativeLabel {
      color: #d3d3d3;
      font-size: 19px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      line-height: 22px;
    }
    .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
      margin-top: 11px;
    }
    .MuiStepLabel-labelContainer .Mui-active {
      color: #666464;
    }
    .MuiStepLabel-labelContainer .Mui-completed {
      color: ${(props) => props.theme.palette.primary.main};
    }
    .MuiSvgIcon-root {
      width: 42px;
      height: 42px;
    }
  }
`;
export default StepsMLStyled;
